export default {
  'subject-card.modules': 'Modules',
  'subject-card.module': 'Module',
  'subject-card.module.download': 'Documenten',
  'subject-card.lessons': 'Lessen',
  'subject-card.lesson': 'Les',
  'subject-card.lesson.download': 'Documenten',
};